import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import routerCfg, {fillPathAppId} from 'routerCfg';
import classnames from 'classnames';
import { useAction } from '@/hooks/useAction';
import { popularList, richList } from '@/api/api';
import styles from './style.scss?__local';
import imgExt from 'assets/img/ext_default.png';
import Utils from 'Utils'
import * as R from 'ramda'

// 小程序商店首页 小程序列表
function App({type, title}) {

  let reqFun = type === 'popular' ? popularList : richList;

  const [extListState, performList, resetList] = useAction(reqFun);
  let [list, setList] = useState([]);

  useEffect(() => {
    resetList()
    performList()
  }, [])

  useEffect(() => {
    const respCode = R.prop("respCode", extListState);
    const respData = R.prop("respData", extListState);

    if (respCode === 0) {
      setList(respData?.list || []);
    }

  }, [extListState.respCode])

  const reportClick = (ID) => {
    console.log(`榜单 点击 埋点`, ID);
    yaReportArr.push({
      eid: 'usr/click/appstore/home/extItem',
      eid_desc: '点击/小程序商店首页/小程序',
      prop: {
        extId: ID,
      },
    })
  }


  return (
    <div className={styles.app}>
      <div className={styles['list-title']}>
        <i className={styles['title-bar']}></i>
        <span className={styles['title-text']}>{title}</span>
      </div>

      <div className={styles['ext-list-content']}>
        {
          (list || []).map((item, idx) => (
            <Link className={styles['ext-list-item']} key={`ext-list-${idx}`} to={ fillPathAppId(routerCfg.path.app, item.extUuid) } onClick = {() => {reportClick(item.extUuid)}} target="_blank">
              <div className={styles['list-item-left']}>
                {
                  idx < 3 ? (
                    <i className={styles[`list-item-idx${idx}`]}></i>
                  ) : (
                    <span className={styles['list-item-idx']}>{idx + 1}</span>
                  )
                }
              </div>

              <div className={styles['list-item-middle']}>
                <img className={styles['list-ext-avatar']} src={item.extLogo || ''}/>
              </div>

              <div className={styles['list-item-right']}>
                <span className={styles['list-ext-name']}>{item.extName || ''}</span>
                {type === 'popular' && (<span className={styles['list-ext-popular']}>{`点赞数：${item.likeNum || 0}`}</span>)}
              </div>
            </Link>
          ))
        }
      </div>
    </div>
  )
}

export default App;
